module.exports = __webpack_public_path__ + "static/media/derecho-laboral.09396db8.jpg";